module.exports = (props) ->
  { text, color, onClick } = props

  <div className='label-text-box' title={text} style={backgroundColor: color} onClick={onClick} />
